module.exports = __webpack_public_path__ + "media/images/ogp/faqs/faq_ogp-e9bd653ff6f6843d26f2d3f853c7ea45.png";